<template lang="pug">
.container-informacoes-pessoais
  .header-informacoes-pessoais
    .label Informações Básicas
    .imagem
      .foto-perfil(@click="selecionarFoto")
        .icone-camera
          LucideIcon(name="Camera" :size="20")
        img(:src="fotoPerfil" alt="Foto do Desenvolvedor")
      input(
        ref="inputFoto"
        type="file"
        accept="image/*"
        style="display: none"
        @change="onFotoSelecionada"
      )
      .click-foto-label Clique na imagem para alterar
  .formulario
    el-form(class="form-custom-nexa" :model="form" ref="formRef" label-width="150px" autocomplete="off")
      el-form-item
        template(slot="label")
          .label-com-icone
            span Nome Completo
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.nome" placeholder="Seu nome completo" autocomplete="new-password")
      el-form-item
        template(slot="label")
          .label-com-icone
            span Apelido/Usuário
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.usuario" placeholder="Seu nome de usuário" autocomplete="new-password" @input="handleUsuarioInput")
      el-form-item
        template(slot="label")
          .label-com-icone
            span Email
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.email" placeholder="seu.email@exemplo.com" type="email" autocomplete="new-password")
      .form-row
        el-form-item(class="form-item-large")
          template(slot="label")
            .label-com-icone
              span Função / Título
              el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
                LucideIcon.icone-visivel(name="Eye" :size="14")
          el-input(v-model="form.funcao" placeholder="Ex: Front-End" autocomplete="new-password")
        el-form-item(label="Telefone" class="form-item-large")
          el-input(v-model="form.telefone" placeholder="(00) 00000-0000" @input="handleTelefoneInput" autocomplete="new-password")
      .form-row
        el-form-item(label="CEP" class="form-item-small")
          el-input(v-model="form.cep" placeholder="00000-000" maxlength="9" @input="handleCepInput" v-loading="loadingCep" autocomplete="new-password")
        el-form-item(label="Endereço" class="form-item-large")
          el-input(v-model="form.endereco" placeholder="Rua, avenida, etc." :disabled="enderecoDisabled" :class="[ enderecoDisabled && 'input-disabled' ]" autocomplete="new-password")
        el-form-item(label="Número" class="form-item-small")
          el-input(v-model="form.numero" placeholder="Número" autocomplete="new-password")
      .form-row
        el-form-item(label="Bairro" class="form-item-medium-large")
          el-input(v-model="form.bairro" placeholder="Bairro" :disabled="bairroDisabled" :class="[ bairroDisabled && 'input-disabled' ]" autocomplete="new-password")
        el-form-item(class="form-item-large")
          template(slot="label")
            .label-com-icone
              span Cidade
              el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
                LucideIcon.icone-visivel(name="Eye" :size="14")
          el-input(v-model="form.cidade" placeholder="Cidade" :disabled="cidadeDisabled" :class="[ cidadeDisabled && 'input-disabled' ]" autocomplete="new-password")
        el-form-item(class="form-item-small")
          template(slot="label")
            .label-com-icone
              span UF
              el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
                LucideIcon.icone-visivel(name="Eye" :size="14")
          el-input(v-model="form.uf" placeholder="UF" maxlength="2" :disabled="ufDisabled" :class="[ ufDisabled && 'input-disabled' ]" autocomplete="new-password")
      el-form-item
        template(slot="label")
          .label-com-icone
            span LinkedIn
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.linkedin" placeholder="https://linkedin.com/in/seu-perfil" autocomplete="new-password" @blur="validateLinkedIn")
        .error-message(v-if="linkedinError") {{ linkedinError }}
      el-form-item
        template(slot="label")
          .label-com-icone
            span GitHub
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.github" placeholder="https://github.com/seu-usuario" autocomplete="new-password" @blur="validateGitHub")
        .error-message(v-if="githubError") {{ githubError }}
      el-form-item
        template(slot="label")
          .label-com-icone
            span Biografia
            el-tooltip(content="Esta informação será exibida no seu perfil público" placement="top" effect="dark")
              LucideIcon.icone-visivel(name="Eye" :size="14")
        el-input(v-model="form.biografia" resize="none" type="textarea" rows="4" placeholder="Conte um pouco sobre você" autocomplete="new-password")
  .btn-salvar
    ButtonPadrao(iconLeft @click="salvarAlteracoes" :loading="salvando")
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import MessageMixin from '@/mixins/MessageMixin'

export default {
  name: 'InformacoesPessoais',
  mixins: [MessageMixin],
  components: {
    ButtonPadrao
  },
  data() {
    return {
      fotoPerfil: require('@/assets/placeholder.svg'),
      fotoFile: null,
      loadingCep: false,
      salvando: false,
      enderecoDisabled: true,
      bairroDisabled: true,
      cidadeDisabled: true,
      ufDisabled: true,
      linkedinError: '',
      githubError: '',
      form: {
        nome: '',
        usuario: '',
        email: '',
        funcao: '',
        telefone: '',
        cep: '',
        endereco: '',
        bairro: '',
        numero: '',
        cidade: '',
        uf: '',
        linkedin: '',
        github: '',
        biografia: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'usuario/getUsuario'
    }),
    currentUser() {
      return this.$store.state.auth.user
    }
  },
  watch: {
    currentUser: {
      handler(newUser) {
        if (newUser && newUser.id) {
          this.carregarDados()
        }
      },
      immediate: true
    },
    'form.linkedin'() {
      // Limpa o erro quando o usuário começar a digitar
      if (this.linkedinError) {
        this.linkedinError = ''
      }
    },
    'form.github'() {
      // Limpa o erro quando o usuário começar a digitar
      if (this.githubError) {
        this.githubError = ''
      }
    }
  },
  mounted() {
    this.carregarDados()
  },
  methods: {
    handleUsuarioInput(value) {
      // Remove espaços, números e caracteres especiais, mantendo apenas letras
      this.form.usuario = value.replace(/[^a-zA-ZÀ-ÿ]/g, '')
    },
    carregarDados() {
      // Busca os dados do usuário do Vuex (que vem do fetchUsuarioById)
      const userData = this.$store.state.auth.user
      
      if (userData) {
        this.form.nome = userData.nome || ''
        this.form.usuario = userData.usuario || ''
        this.form.email = userData.email || ''
        this.form.funcao = userData.funcao || ''
        this.form.telefone = userData.telefone || ''
        this.form.cep = userData.cep || ''
        this.form.endereco = userData.endereco || ''
        this.form.bairro = userData.bairro || ''
        this.form.numero = userData.numero || ''
        this.form.cidade = userData.cidade || ''
        this.form.uf = userData.uf || ''
        this.form.linkedin = userData.linkedin || ''
        this.form.github = userData.git || '' // API retorna 'git' não 'github'
        this.form.biografia = userData.biografia || ''
        
        // Carrega a foto de perfil se existir
        if (userData.foto_perfil) {
          // Garante que a foto tem o prefixo data URI correto
          const foto = userData.foto_perfil
          if (foto.startsWith('data:image')) {
            this.fotoPerfil = foto
          } else {
            // Adiciona o prefixo se não existir
            this.fotoPerfil = `data:image/jpeg;base64,${foto}`
          }
        } else {
          this.fotoPerfil = require('@/assets/placeholder.svg')
        }
        
        // Se já tem endereço preenchido, desbloqueia os campos
        if (userData.endereco) {
          this.enderecoDisabled = false
          this.bairroDisabled = true
          this.cidadeDisabled = true
          this.ufDisabled = true
        }
      }
    },
    formatCep(value) {
      // Remove tudo que não é número
      let cep = value.replace(/\D/g, '')
      
      // Adiciona o hífen após 5 dígitos
      if (cep.length > 5) {
        cep = cep.substring(0, 5) + '-' + cep.substring(5, 8)
      }
      
      return cep
    },
    formatTelefone(value) {
      // Remove tudo que não é número
      let telefone = value.replace(/\D/g, '')
      
      // Limita a 11 dígitos
      telefone = telefone.substring(0, 11)
      
      // Aplica formatação progressiva
      if (telefone.length === 0) {
        return ''
      } else if (telefone.length <= 2) {
        // (00
        return `(${telefone}`
      } else if (telefone.length <= 6) {
        // (00) 0000
        return `(${telefone.substring(0, 2)}) ${telefone.substring(2)}`
      } else if (telefone.length <= 10) {
        // (00) 0000-0000
        return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 6)}-${telefone.substring(6)}`
      } else {
        // (00) 00000-0000
        return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 7)}-${telefone.substring(7)}`
      }
    },
    handleTelefoneInput(value) {
      this.form.telefone = this.formatTelefone(value)
    },
    handleCepInput(value) {
      // Formata o CEP
      this.form.cep = this.formatCep(value)
      
      // Busca endereço quando CEP estiver completo (8 dígitos)
      // Só executa se não houver endereço já preenchido
      const cepLimpo = this.form.cep.replace(/\D/g, '')
      if (cepLimpo.length === 8 && !this.form.endereco) {
        this.buscarEndereco()
      }
    },
    async buscarEndereco() {
      const cep = this.form.cep.replace(/\D/g, '')
      
      if (cep.length !== 8) {
        return
      }
      
      this.loadingCep = true
      
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        const data = await response.json()
        
        if (data.erro) {
          this.showWarningMessage('CEP não encontrado. Preencha os campos manualmente.')
          // Desbloqueia todos os campos para preenchimento manual
          this.enderecoDisabled = false
          this.bairroDisabled = false
          this.cidadeDisabled = false
          this.ufDisabled = false
          this.loadingCep = false
          return
        }
        
        this.form.endereco = data.logradouro || ''
        this.form.bairro = data.bairro || ''
        this.form.cidade = data.localidade || ''
        this.form.uf = data.uf || ''
        
        // Desbloqueia apenas o campo de endereço após carregar com sucesso
        // Bairro, Cidade e UF ficam bloqueados
        this.enderecoDisabled = false
        this.bairroDisabled = true
        this.cidadeDisabled = true
        this.ufDisabled = true
        
      } catch (error) {
        this.showErrorMessage('Erro ao buscar CEP. Preencha os campos manualmente.')
        // Desbloqueia todos os campos em caso de erro
        this.enderecoDisabled = false
        this.bairroDisabled = false
        this.cidadeDisabled = false
        this.ufDisabled = false
        console.error('Erro ao buscar CEP:', error)
      } finally {
        this.loadingCep = false
      }
    },
    selecionarFoto() {
      if (this.$refs.inputFoto) this.$refs.inputFoto.click()
    },
    onFotoSelecionada(event) {
      const file = event.target.files && event.target.files[0]
      if (file) {
        // Salva o arquivo para enviar depois
        this.fotoFile = file
        
        // Mostra preview
        const reader = new FileReader()
        reader.onload = e => {
          this.fotoPerfil = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    validateLinkedIn() {
      // Se o campo estiver vazio, não há erro
      if (!this.form.linkedin || this.form.linkedin.trim() === '') {
        this.linkedinError = ''
        return true
      }

      // Regex para validar URLs do LinkedIn (permite várias variações)
      const linkedinRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school)\/[a-zA-Z0-9_-]+\/?$/i
      
      if (!linkedinRegex.test(this.form.linkedin.trim())) {
        this.linkedinError = 'URL do LinkedIn inválida. Use o formato: https://linkedin.com/in/seu-perfil'
        return false
      }
      
      this.linkedinError = ''
      return true
    },
    validateGitHub() {
      // Se o campo estiver vazio, não há erro
      if (!this.form.github || this.form.github.trim() === '') {
        this.githubError = ''
        return true
      }

      // Regex para validar URLs do GitHub (permite perfis e organizações)
      const githubRegex = /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9_-]+\/?$/i
      
      if (!githubRegex.test(this.form.github.trim())) {
        this.githubError = 'URL do GitHub inválida. Use o formato: https://github.com/seu-usuario'
        return false
      }
      
      this.githubError = ''
      return true
    },
    async salvarAlteracoes() {
      const userStorage = JSON.parse(localStorage.getItem('user-nexa'))
      const userId = userStorage?.id
      
      if (!userId) {
        this.showErrorMessage('Usuário não identificado')
        return
      }
      
      // Valida campos obrigatórios
      if (!this.form.usuario || this.form.usuario.trim() === '') {
        this.showWarningMessage('O campo Apelido/Usuário é obrigatório')
        return
      }

      // Valida LinkedIn e GitHub
      const linkedinValid = this.validateLinkedIn()
      const githubValid = this.validateGitHub()

      if (!linkedinValid || !githubValid) {
        this.showErrorMessage('Corrija os erros nos campos de LinkedIn e/ou GitHub antes de salvar')
        return
      }
      
      this.salvando = true
      
      // Usa JSON normal sem FormData por enquanto (sem foto)
      const payload = {
        id: parseInt(userId),
        nome: this.form.nome || '',
        usuario: this.form.usuario,
        email: this.form.email || '',
        funcao: this.form.funcao || '',
        telefone: this.form.telefone || '',
        cep: this.form.cep || '',
        endereco: this.form.endereco || '',
        numero: this.form.numero || '',
        bairro: this.form.bairro || '',
        cidade: this.form.cidade || '',
        uf: this.form.uf || '',
        linkedin: this.form.linkedin || '',
        git: this.form.github || '',
        biografia: this.form.biografia || '',
        foto_perfil: this.fotoPerfil !== require('@/assets/placeholder.svg') ? this.fotoPerfil : null
      }
      
      try {
        const result = await this.$store.dispatch('usuario/updateUsuario', payload)
        
        if (result.success) {
          this.showSuccessMessage('Alterações salvas com sucesso!')
          
          // Atualiza os dados do usuário
          await this.$store.dispatch('usuario/fetchUsuarioById', userId)
        } else {
          this.showErrorMessage(result.error || 'Erro ao salvar alterações')
        }
        
      } catch (error) {
        console.error('Erro ao salvar alterações:', error)
        this.showErrorMessage('Erro ao salvar alterações')
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>

<style lang="scss">
.container-informacoes-pessoais{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .header-informacoes-pessoais{
    padding: 24px;
    box-sizing: border-box;

    .label{
      font-size: 20px;
      font-weight: 700;
      color: $corVerdeClaro;
      margin-bottom: 24px;
    }
    .imagem{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .foto-perfil {
        width: 96px;
        height: 96px;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid $corVerdeClaro;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        z-index: 0;

        .icone-camera {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 4;
          opacity: .3;
        }
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.45);
          opacity: 0;
          transition: opacity 0.2s;
          z-index: 3;
          border-radius: 50%;
          pointer-events: none;
        }
        
        &:hover{
          color: $corVerdeClaro;  
          &::after {
            opacity: 1;
          }

          .icone-camera{
            opacity: 1;
          }
        }
      }
      .click-foto-label{
        margin-top: 8px;
        color: $corValueInfoContato;
        font-size: 14px;
      }
    }
  }
  .formulario{
    padding: 0 24px 24px;
    box-sizing: border-box;

    .label-com-icone {
      display: flex;
      align-items: center;
      gap: 6px;

      span {
        color: inherit;
      }

      .icone-visivel {
        color: $corVerdeClaro;
        cursor: help;
        transition: all 0.2s ease;
        flex-shrink: 0;

        &:hover {
          color: #d4ff3d;
          transform: scale(1.1);
        }
      }
    }

    .form-row {
      display: flex;
      gap: 16px;
      width: 100%;

      .el-form-item {
        margin-bottom: 10px;

        &.form-item-small {
          flex: 0 0 150px;
        }

        &.form-item-medium {
          flex: 0 0 200px;
        }

        &.form-item-medium-large {
          flex: 1;
        }

        &.form-item-large {
          flex: 1;
        }
      }
    }

    .input-disabled {
      .el-input__inner {
        background-color: #1a1a1a !important;
        color: #6b7280 !important;
        cursor: not-allowed !important;
      }
    }

    .error-message {
      color: #f87171;
      font-size: 12px;
      margin-top: -8px;
      margin-bottom: 10px;
      padding-left: 2px;
    }

    .el-input__count {
      background: transparent !important;
      color: $corValueInfoContato !important;
    }

    .enviar-mensagem{
      width: 100%;
      margin-top: 20px;

      .botao{
        width: 100%;
      }
    }
  }
  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .formulario {
      .form-row {
        flex-direction: column;
        gap: 0;

        .el-form-item {
          &.form-item-small,
          &.form-item-large {
            flex: 1;
            width: 100%;
          }
        }
      }
    }

    .btn-salvar{
      justify-content: center;
    }
  }
}
</style>